import React from 'react';
import { ContentWrapper } from '../../containers';
import * as S from './styles';
import Logo from '@/components/logo';
export class Footer extends React.Component {
    render() {
        return (
            <S.Container>
                <ContentWrapper className="flex justify-between items-center h-full">
                    <div className="flex text-gray-500 relative place-content-start my-auto items-center space-x-1">
                        <Logo className="text-white h-3" />
                    </div>
                </ContentWrapper>
            </S.Container>
        )
    }
}